export default ({request}) => ({
  sysCustomerExportTemplateListByDisplayApi(data = {}) {
    return request({
      url: '/sys/customer/export/template/listByDisplay',
      method: 'post',
      data,
    })
  },
  sysCustomerExportTemplateDetailApi(data = {}) {
    return request({
      url: '/sys/customer/export/template/detail',
      method: 'post',
      data,
    })
  },
  sysCustomerExportTemplateSaveApi(data = {}) {
    return request({
      url: '/sys/customer/export/template/save',
      method: 'post',
      data,
    })
  },
  sysCustomerExportTemplateDelApi(data = {}) {
    return request({
      url: '/sys/customer/export/template/del',
      method: 'post',
      data,
    })
  },
})
